import { keyBy, set, get, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  fetchInventoryLocationZones,
  createInventoryLocationZone,
  deleteInventoryLocationZone
} from '../../sagas/routines';

const initialState = {
  zonesByLocationId: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

export const createFetchByLocationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    zonesByLocationId: {
      ...state.zonesByLocationId,
      [get('0.inventoryLocationId', response.items)]: keyBy(
        'id',
        response.items
      )
    }
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createSaveHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    saved: true,
    zonesByLocationId: {
      ...state.zonesByLocationId,
      [response.inventoryLocationId]: set(
        response.id,
        response,
        state.zonesByLocationId[response.inventoryLocationId]
      )
    }
  }),
  [routine.FAILURE]: (state, error) => set('savingError', error, state),
  [routine.FULFILL]: set('saving', false)
});

export const createDeleteHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, deleting: true, deleted: false }),
  [routine.SUCCESS]: (state, { payload: { id, inventoryLocationId } }) => ({
    ...state,
    deleted: true,
    zonesByLocationId: {
      ...state.zonesByLocationId,
      [inventoryLocationId]: omit(
        id,
        state.zonesByLocationId[inventoryLocationId]
      )
    }
  }),
  [routine.FAILURE]: (state, { error }) => set('deletingError', error, state),
  [routine.FULFILL]: set('deleting', false)
});

export default createReducer(initialState, {
  ...createFetchByLocationHandler(fetchInventoryLocationZones),
  ...createSaveHandler(createInventoryLocationZone),
  ...createDeleteHandler(deleteInventoryLocationZone)
});
